$(document).ready(function () {
    headerScroll()

    $(document).on('scroll', function () {
        headerScroll()
    })
})

$(document).on('click', '.js_header__main-burger', function () {
    $('.js_header__burger').addClass('active')
})

$(document).on('click', '.js_header__burger-close', function () {
    $('.js_header__burger').removeClass('active')
    $('.js_header__submen').removeClass('active')
    setTimeout(function() {
        closeSubmenu()
    },300)
})

$(document).on('click', function (e) {
    if (!$(e.target).closest('.js_header__burger').length && !$(e.target).hasClass('js_header__main-burger')) {
        $('.js_header__burger').removeClass('active')
    }
})

$(document).on('click', '.js_header__menu-link', function () {
    let dataMenu = $(this).attr('data-menu')
    let banerName = $(this).text().trim()
    if (!$(this).hasClass('active')) {
        $('.js_header__menu-link').removeClass('active')
        $(this).addClass('active')
        $('.js_header__submenu-container').addClass('active')
        $('.js_header__submenu-list').removeClass('active')
        $(`.js_header__submenu-list[data-menu="${dataMenu}"]`).addClass('active')
        $('.js_header__news-item').removeClass('active')
        $(`.js_header__news-item[data-baner="${banerName}"]`).addClass('active')
        $('.js_header__submenu').addClass('active')
        closeLastmenu()
    } else {
        closeSubmenu()
    }
})

$(document).on('click', '.js_header__main-search', function () {
    if (!$('.js_header__search').hasClass('active')) {
        $(this).addClass('active')
        $('.js_header').addClass('search')
        setTimeout(function () {
            $('.js_header__search').addClass('active')
        }, 300)
    } else {
        closeHeaderSearh()
    }
})

$(document).on('click', function (e) {
    if (!$(e.target).closest('.js_header__search').length && !$(e.target).closest('.js_header__main-search').length) {
        closeHeaderSearh()
    }
})

$(document).on('input', '.js_header__search-input', function() {
    if ($(this).val().length > 0) {
        $('.js_header__search-remove').addClass('active')
    } else {
        $('.js_header__search-remove').removeClass('active')
    }
})

$(document).on('click', '.js_header__search-remove', function() {
    $(this).removeClass('active')
    $('.js_header__search-input').val('')
})

$(document).on('keyup', '.js_header__search-input', function(e) {
    if (e.keycode == '13' || event.key === 'Enter') {
        let value = $(this).val().trim()
        let url = new URL(window.location.href)
        url.pathname = `/${lang}/search`
        url.searchParams.set('search', value)
        window.location.href = url.href
    }
})

$(document).on('click', '.js_header__submenu-title', function() {
    closeSubmenu()
})

$(document).on('click', '.js_header__submenu-button', function() {
    let attr = `[data-subitem=${$(this).attr('data-subitem')}]`
    if (!$(this).hasClass('active')) {
        $('.js_header-lastmenu').addClass('active')
        $('.js_header__submenu-button').removeClass('active')
        $(this).addClass('active')
        $('.js_header__news').removeClass('active')
        $('.js_header-lastmenu__item').removeClass('active')
        $(`.js_header-lastmenu__item${attr}`).addClass('active')
    } else {
        closeLastmenu()
    }
})

$(document).on('click', '.js_header-lastmenu__title', function() {
    closeLastmenu()
})

function headerScroll() {
    if (!$('.js_header').hasClass('dark')) {
        if ($(window).scrollTop() > 0) {
            $('.js_header').addClass('scroll')
        } else {
            $('.js_header').removeClass('scroll')
        }
    }
}

function closeHeaderSearh() {
    $('.js_header__main-search').removeClass('active')
    $('.js_header__search').removeClass('active')
    setTimeout(function () {
        $('.js_header').removeClass('search')
    }, 300)
}

function closeSubmenu() {
    $('.js_header__submenu').removeClass('active')
    $('.js_header__submenu-container').removeClass('active')
    $('.js_header__submenu-list').removeClass('active')
    $('.js_header__menu-link').removeClass('active')
    closeLastmenu()
}

function closeLastmenu() {
    $('.js_header-lastmenu').removeClass('active')
    $('.js_header__submenu-button').removeClass('active')
    $('.js_header-lastmenu__item').removeClass('active')
    $('.js_header__news').addClass('active')
}